"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _commonStore = _interopRequireDefault(require("@audacious/web-common/lib/stores/common-store"));

var _map = _interopRequireDefault(require("lodash/map"));

var _get = _interopRequireDefault(require("lodash/get"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _reverse = _interopRequireDefault(require("lodash/reverse"));

var _formatPatient = _interopRequireDefault(require("../common/util/format-patient"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function formatPatients(patients) {
  var errorPatients = (0, _filter.default)(patients, function (patient) {
    return patient.issues && patient.issues.length > 0;
  });
  var successPatients = (0, _filter.default)(patients, function (patient) {
    return !patient.issues || patient.issues.length === 0;
  });
  var sortedPatients = [].concat((0, _toConsumableArray2.default)(errorPatients), (0, _toConsumableArray2.default)(successPatients));
  return (0, _map.default)(sortedPatients, function (patientData) {
    var patient = patientData.patient;
    return _objectSpread(_objectSpread({}, patientData), {}, {
      formatted: (0, _formatPatient.default)(_objectSpread(_objectSpread({}, patient), {}, {
        addressLine1: patient.address1,
        addressLine2: patient.address2,
        zipCode: patient.zip
      }))
    });
  });
}

var initialState = {
  importedPanel: [],
  importedPanelError: '',
  importedPanelFileName: '',
  reviewImportedPanel: false,
  submitPanelHasError: false,
  successfulReportCreation: false,
  loadingPanels: false,
  loadingReports: false,
  panels: [],
  reports: []
};

var MissingPersonsStore = /*#__PURE__*/function (_CommonStore) {
  (0, _inherits2.default)(MissingPersonsStore, _CommonStore);

  var _super = _createSuper(MissingPersonsStore);

  function MissingPersonsStore(dispatcher) {
    (0, _classCallCheck2.default)(this, MissingPersonsStore);
    return _super.call(this, dispatcher, initialState);
  }

  (0, _createClass2.default)(MissingPersonsStore, [{
    key: "createReportStart",
    value: function createReportStart() {
      this.setState({
        successfulReportCreation: false
      });
    }
  }, {
    key: "createReportFinish",
    value: function createReportFinish(report) {
      var reports = this.state.reports;
      reports.unshift(report);
      this.setState({
        reports: reports,
        successfulReportCreation: true
      });
    }
  }, {
    key: "getReports",
    value: function getReports() {
      var reports = this.state.reports;
      return reports;
    }
  }, {
    key: "getLoadingReports",
    value: function getLoadingReports() {
      var loadingReports = this.state.loadingReports;
      return loadingReports;
    }
  }, {
    key: "getSuccessfulReportCreation",
    value: function getSuccessfulReportCreation() {
      var successfulReportCreation = this.state.successfulReportCreation;
      return successfulReportCreation;
    }
  }, {
    key: "importPanelFinish",
    value: function importPanelFinish(panel) {
      var formattedPanel = formatPatients(panel);
      this.setState({
        importedPanel: formattedPanel,
        reviewImportedPanel: true,
        submitPanelHasError: false,
        importedPanelError: ''
      });
    }
  }, {
    key: "importPanelFailed",
    value: function importPanelFailed(error) {
      this.setState({
        importedPanelError: (0, _get.default)(error, 'message', 'Unknown Error')
      });
    }
  }, {
    key: "getImportedPanelError",
    value: function getImportedPanelError() {
      return this.state.importedPanelError;
    }
  }, {
    key: "clearImportPanelError",
    value: function clearImportPanelError() {
      this.setState({
        importedPanelError: ''
      });
    }
  }, {
    key: "uploadPanelFinish",
    value: function uploadPanelFinish(newPanel) {
      var panels = this.state.panels;
      panels.push(newPanel[0]);
      this.setState({
        panels: panels
      });
    }
  }, {
    key: "exitReviewPanel",
    value: function exitReviewPanel() {
      this.setState({
        reviewImportedPanel: false,
        submitPanelHasError: false
      });
    }
  }, {
    key: "removeErrorPanelItems",
    value: function removeErrorPanelItems() {
      var successPatients = (0, _filter.default)(this.state.importedPanel, function (patient) {
        return !patient.issues || patient.issues.length === 0;
      });
      this.setState({
        importedPanel: successPatients
      });
    }
  }, {
    key: "getImportedPanel",
    value: function getImportedPanel() {
      var importedPanel = this.state.importedPanel;
      return importedPanel;
    }
  }, {
    key: "getPanels",
    value: function getPanels() {
      var panels = this.state.panels;
      return panels;
    }
  }, {
    key: "submitPanelFailed",
    value: function submitPanelFailed() {
      this.setState({
        submitPanelHasError: true
      });
    }
  }, {
    key: "getSubmitPanelHasError",
    value: function getSubmitPanelHasError() {
      var submitPanelHasError = this.state.submitPanelHasError;
      return submitPanelHasError;
    }
  }, {
    key: "getPanelsStart",
    value: function getPanelsStart() {
      this.setState({
        loadingPanels: true
      });
    }
  }, {
    key: "getPanelsFinish",
    value: function getPanelsFinish(newPanels) {
      this.setState({
        panels: (0, _reverse.default)(newPanels),
        loadingPanels: false
      });
    }
  }, {
    key: "getPanelsFailed",
    value: function getPanelsFailed() {
      this.setState({
        loadingPanels: false
      });
    }
  }, {
    key: "setImportedPanelFileName",
    value: function setImportedPanelFileName(fileName) {
      this.setState({
        importedPanelFileName: fileName
      });
    }
  }, {
    key: "getImportedPanelFileName",
    value: function getImportedPanelFileName() {
      var _this$getState = this.getState(),
          importedPanelFileName = _this$getState.importedPanelFileName;

      return importedPanelFileName;
    }
  }, {
    key: "getReportsStart",
    value: function getReportsStart() {
      this.setState({
        loadingReports: true
      });
    }
  }, {
    key: "getReportsFinish",
    value: function getReportsFinish(newReports) {
      this.setState({
        reports: newReports,
        loadingReports: false
      });
    }
  }, {
    key: "getReportsFailed",
    value: function getReportsFailed() {
      this.setState({
        loadingReports: false
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return MissingPersonsStore;
}(_commonStore.default);

MissingPersonsStore.storeName = 'MissingPersonsStore';
MissingPersonsStore.handlers = {
  CREATE_REPORT_FINISH: 'createReportFinish',
  CREATE_REPORT_START: 'createReportStart',
  IMPORT_PANEL_FINISH: 'importPanelFinish',
  IMPORT_PANEL_FAILED: 'importPanelFailed',
  CLEAR_IMPORT_PANEL_ERROR: 'clearImportPanelError',
  UPLOAD_PANEL_FINISH: 'uploadPanelFinish',
  EXIT_REVIEW_PANEL: 'exitReviewPanel',
  REMOVE_ERROR_PANEL_ITEMS: 'removeErrorPanelItems',
  SUBMIT_PANEL_FAILED: 'submitPanelFailed',
  GET_PANELS_START: 'getPanelsStart',
  GET_PANELS_FINISH: 'getPanelsFinish',
  GET_PANELS_FAILED: 'getPanelsFailed',
  SET_IMPORT_PANEL_FILE_NAME: 'setImportedPanelFileName',
  GET_REPORTS_START: 'getReportsStart',
  GET_REPORTS_FINISH: 'getReportsFinish',
  GET_REPORT_FAILED: 'getReportsFailed'
};
var _default = MissingPersonsStore;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatPatients, "formatPatients", "/builds/pulse-platform/pulse-missingperson-web-application/src/stores/missing-persons-store.js");
  reactHotLoader.register(initialState, "initialState", "/builds/pulse-platform/pulse-missingperson-web-application/src/stores/missing-persons-store.js");
  reactHotLoader.register(MissingPersonsStore, "MissingPersonsStore", "/builds/pulse-platform/pulse-missingperson-web-application/src/stores/missing-persons-store.js");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/stores/missing-persons-store.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();